

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'
import foto_5 from './foto_5.jpg'
import foto_6 from './foto_6.jpg'
import foto_7 from './foto_7.jpg'
import foto_8 from './foto_8.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>Creación e implementación PESEM 2025
</h3>
                <p>
                    En el marco de la Dimensión Estratégica Empresarial, COOPMULMAG avanza 
                    en la socialización, creación e implementación del Plan Estratégico Socio 
                    empresarial PESEM 2025-2030. Esta jornada de análisis diagnóstico permite 
                    identificar fortalezas y oportunidades de mejora, orientando acciones concretas 
                    para el fortalecimiento organizacional y el desarrollo sostenible de nuestra cooperativa
                    </p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}